// removed by extract-text-webpack-plugin
module.exports = {"container":"app__container___2TXwI typo__body___1Xlj-","dartboardSVG":"app__dartboardSVG___3w1v2"};


//////////////////
// WEBPACK FOOTER
// ./containers/App/app.css
// module id = 276
// module chunks = 0